<div>
  <label class="visual-checkbox flex row h-[64px] w-[171px] md:h-[80px] md:w-[204px] {{ visCheckClass }}">
    <i class="icon-{{ icon }} text-xl"></i>
    <span class="{{ spanClass }}">{{ mainText }}</span>
  </label>
</div>
